export default "__VITE_ASSET__BLhX86Q4__"